import { motion } from 'framer-motion';
import React from 'react';
import { OverlayingPopup } from '@/components/elements/OverlayingPopup';
import { CloseButton } from '@/components/UI';
import { popupMotion } from '../../animation';
import { useCookiesContext } from '../../context';
import { CookiesActions } from './CookiesActions';
import { CookiesBody } from './CookiesBody';
import styles from './CookiesPopup.module.scss';

export const CookiesPopup: React.FC = () => {
	// Context
	const { setCookiesSettings } = useCookiesContext();

	// Actions
	const onClose = () => {
		setCookiesSettings(state => ({
			...state,
			popup: false,
		}));
	};

	return (
		<OverlayingPopup
			onClose={onClose}
			classes={{
				popup: styles['popup'],
				overlay: styles['popup__overlay'],
			}}
			escapeClose
		>
			<motion.div
				className={styles['popup__container']}
				// Animation
				{...popupMotion}
			>
				<div className={styles['popup__wrapper']}>
					<div className={styles['popup__header']}>
						<CloseButton
							onClick={onClose}
							classes={{
								button: styles['popup__close'],
								icon: styles['popup__close-icon'],
							}}
						/>
					</div>

					<CookiesBody />
				</div>

				<CookiesActions />
			</motion.div>
		</OverlayingPopup>
	);
};
